import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PersonFormModel } from '@base/models/form/person-form.model';
import { createAddressForm } from './address-form.factory';

export function createPersonForm(): FormGroup<PersonFormModel> {
  return new FormGroup<PersonFormModel>({
    firstname: new FormControl<string | null>(null, [Validators.required]),
    lastname: new FormControl<string | null>(null, [Validators.required]),
    email: new FormControl<string | null>(null, [Validators.required, Validators.email]),
    phone: new FormControl<string | null>(null),
    address: createAddressForm()
  });
}

